const options = {
  5: "bg-zinc-300/5",
  10: "bg-zinc-300/10",
  25: "bg-zinc-300/25",
  50: "bg-zinc-300/50",
  75: "bg-zinc-300/75",
  90: "bg-zinc-300/90",
  100: "bg-zinc-300",
};

const from = {
  5: "from-zinc-300/5",
  10: "from-zinc-300/10",
  25: "from-zinc-300/25",
  50: "from-zinc-300/50",
  75: "from-zinc-300/75",
  90: "from-zinc-300/90",
  100: "from-zinc-300",
};

export default function getBackgroundZinc300(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
